import { Component, computed, EventEmitter, inject, Output } from '@angular/core'
import { AccountDataComponent } from '../account-data/account-data.component'
import { TranslationService } from '../services/translation/translation.service'
import { AuthService } from '../services/auth/auth.service'
import { TranslateModule } from '@ngx-translate/core'

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrl: './toolbar.component.scss',
    imports: [AccountDataComponent, TranslateModule],
})
export class ToolbarComponent {
    @Output() toggleSidenav = new EventEmitter()

    translationService = inject(TranslationService)

    /** Empty when the logged-in account has no organization (e.g. local/non-MUA accounts). */
    readonly nomeAzienda: string = inject(AuthService).getUserResult()?.nomeAzienda ?? ''

    readonly languages = [
        { code: 'en', flag: 'us', key: 'ENGLISH' },
        { code: 'es', flag: 'es', key: 'SPANISH' },
        { code: 'it', flag: 'it', key: 'ITALIAN' },
        { code: 'fr', flag: 'fr', key: 'FRENCH' },
        { code: 'pt', flag: 'pt', key: 'PORTUGUESE' },
    ]

    currentFlag = computed(() => {
        const lang = this.translationService.languageSignal()
        return this.languages.find((l) => l.code === lang)?.flag ?? 'us'
    })

    toggleSnav() {
        this.toggleSidenav.emit()
    }

    changeLang(code: string) {
        this.translationService.languageSignal.set(code)
    }

    getLanguageTranslationKey(): string {
        return this.languages.find((l) => l.code === this.translationService.languageSignal())?.key ?? 'ENGLISH'
    }
}
